import {Mapper} from '@s-ui/domain'

export default class PurchaseCheckoutRawDataToPurchaseCheckoutEntityMapper extends Mapper {
  constructor({entity}) {
    super()
    this._entity = entity
  }

  map = purchase => this._entity(purchase)
}
